<template>
  <div v-if="regroupementProduit">
    <div class="entete">
      <div class="level">
        <div class="level-left">
          <div class="columns is-gapless">
            <div class="column">
              <h1 class="title is-size-3">
                {{ $t('detailRegroupementProduit.title',
                { libelle: regroupementProduit.libelle }) }}
              </h1>
              <app-breadcrumb :breadcrumb="breadcrumb"/>
            </div>
          </div>
        </div>
        <div class="level-right">
          <div class="buttons">
            <dropdownButton
              type="is-addOrEdit"
              class="mgr-2"
              :permission="permissions.maj"
              :actions="actionSecondary"
              @click="() => {
                $router.push({
                      name: 'm.bodac.catalogue-addEditRegroupementProduit',
                      params: { id: regroupementProduit.id },
                    });
              }">
                {{ $t('detail.buttons.edit') }}
            </dropdownButton>
          </div>
        </div>
      </div>
    </div>
    <div class="tab">
      <ul>
        <li
          v-for="(tab, index) in tabs" :key="index"
          :class="{'is-active': activeTab === tab}"
          @click="activeTab = tab">
          {{ $t(`detailRegroupementProduit.tabs.${tab}`) }}
        </li>
      </ul>
    </div>
    <section class="corps">
      <component
        :is="activeTab"
        :detail="true"
        :regroupementProduit="regroupementProduit"
        :produit="produitRegroupement"
        :permissions="permissions"
      />
    </section>
    <b-modal v-model="popUpSuppression" has-modal-card class="modal">
      <pop-up-prevention
        :mess-header="$t('listeRegroupementProduit.popUpSuppression.title')"
        :cancel="$t('general.non')"
        :validate="$t('general.oui')"
        @no="popUpSuppression = false"
        @yes="deleteRegroupement"/>
    </b-modal>
  </div>
</template>

<script>
import dropdownButton from '@/components/general/button/dropdownButton';
import { get, deleteAsync } from '@/api/produit/regroupementProduit';
import messageErreur from '@/services/general/messageErreur';
import AppBreadcrumb from '@/components/general/breadcrumb';
import errorMsgComponent from '@/components/general/errorMsgComponent';
import Informations from '@/components/presse/regroupementProduit/informations';
import Produits from '@/components/presse/regroupementProduit/produits';
import regleCommission from '@/components/catalogue/produitGeneralPresse/edition/regleCommission';
import objectifVente from '@/components/catalogue/produitGeneralPresse/edition/objectifVente';
import reglesAchat from '@/components/catalogue/produitGeneralPresse/edition/reglesAchat';
import cgv from '@/components/catalogue/produitGeneralPresse/edition/cgv';
import { CATALOGUE } from '@/configuration/permissionsBodacConf';
import PopUpPrevention from '@/components/general/popUpPrevention';
import messageSucces from '@/services/general/messageSucces';

export default {
  components: {
    AppBreadcrumb,
    dropdownButton,
    errorMsgComponent,
    Informations,
    Produits,
    regleCommission,
    objectifVente,
    reglesAchat,
    cgv,
    PopUpPrevention,
  },
  data() {
    return {
      permissions: CATALOGUE,
      regroupementProduit: null,
      error: false,
      messages: [],
      champsVide: [],
      messagesChampsVide: [],
      activeTab: 'informations',
      popUpSuppression: false,
    };
  },
  computed: {
    tabs() {
      return [
        'informations',
        'produits',
        'regleCommission',
        'objectifVente',
        'reglesAchat',
        'cgv',
      ];
    },
    dataAlreadyExist() {
      return this.regroupementProduit && !!(this.regroupementProduit.id);
    },
    breadcrumb() {
      return [
        { title: this.$i18n.t('detailRegroupementProduit.breadcrumb.racine'), route: this.$PAGE_DEFAULT, isActive: false },
        { title: this.$i18n.t('detailRegroupementProduit.breadcrumb.liste'), route: { name: 'l.bodac.catalogue-regroupementProduit' }, isActive: false },
        { title: this.$i18n.t('detailRegroupementProduit.breadcrumb.detail', { libelle: this.regroupementProduit.libelle }), route: { name: '' }, isActive: true },
      ];
    },
    produitRegroupement() {
      let produitId = null;
      if (this.regroupementProduit.produits.length) {
        produitId = this.regroupementProduit.produits[0].id;
      }
      return {
        ...this.regroupementProduit,
        id: produitId,
      };
    },
    actionSecondary() {
      const actions = [
        {
          label: this.$t('general.button.delete'),
          action: () => { this.popUpSuppression = true; },
          permissionAction: CATALOGUE.supprimer,
        },
      ];

      return actions;
    },
  },
  methods: {
    async deleteRegroupement() {
      const loadingComponent = this.$buefy.loading.open();
      try {
        await deleteAsync(this.regroupementProduit.id);
        messageSucces(this.$t('listeRegroupementProduit.popUpSuppression.sucessDelete'));
        loadingComponent.close();
        this.$router.push({ name: 'l.bodac.catalogue-regroupementProduit' });
      } catch (e) {
        messageErreur(this.$i18n);
        loadingComponent.close();
        throw e;
      }
    },
  },
  async mounted() {
    const loadingComponent = this.$buefy.loading.open();
    try {
      const regroupementProduit = (await get(this.$route.params.id)).data.result;
      this.setInformationPage(this.$t('pageGeneral.detail', { item: regroupementProduit.libelle }));
      regroupementProduit.commissionsVendeur.forEach((el) => {
        el.dateDebut = new Date(el.dateDebut);
        if (el.dateFin) el.dateFin = new Date(el.dateFin);
        el.selected = false;
      });
      regroupementProduit.reglesAchat.forEach((el) => {
        el.dateDebut = new Date(el.dateDebut);
        if (el.dateFin) el.dateFin = new Date(el.dateFin);
        el.selected = false;
      });
      regroupementProduit.objectifsVente.forEach((el) => { el.selected = false; });
      regroupementProduit.cgvs.forEach((el) => { el.selected = false; });
      this.regroupementProduit = regroupementProduit;
      loadingComponent.close();
    } catch (e) {
      loadingComponent.close();
      messageErreur(this.$i18n);
      throw e;
    }
  },
};
</script>
